import { render, staticRenderFns } from "./ListUser.vue?vue&type=template&id=36fe2c5a&scoped=true"
import script from "./ListUser.vue?vue&type=script&lang=js"
export * from "./ListUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe2c5a",
  null
  
)

export default component.exports